export class SftpRegistration {
    id: number;
    districtAcctNumber: number;
    accountAssociations: SftpAccountAssociation[];
    syncEnabled: boolean;
    syncInitialized: boolean;
    syncStatus: string;
    lastSyncError: string;
    lastSyncErrorAt: Date;
    lastSyncedAt: Date;
    syncCrunJob: string;
    organizationCount: number;
    studentCount: number;
    studentContactCount: number;
    isHostedServer: boolean;
    sftpConfig: SftpConfig;
    csvMapping: any;
    createdAt: Date;
    updatedAt: Date;

    constructor() {
        this.id = 0;
        this.districtAcctNumber = 0;
        this.accountAssociations = [];
        this.syncEnabled = true;
        this.syncInitialized = false;
        this.syncStatus = '';
        this.lastSyncError = '';
        this.lastSyncErrorAt = new Date();
        this.lastSyncedAt = new Date();
        this.organizationCount = 0;
        this.studentCount = 0;
        this.studentContactCount = 0;
        this.syncCrunJob = '0 22 * * *';
        this.isHostedServer = false;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}

export class SftpAccountAssociation {
    acctNumber: number;
    organizationSourceId: string;
    syncStudents: boolean;
    syncStudentContacts: boolean;
    syncEnabled: boolean;
}

export class SftpConfig {
    client: {
        host: string;
        port: number;
        username: string;
        password?: string;
    };
    file: {
        remotePath: string;
        fileNamePattern: string;
    };
}
